import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import EventModel from '../EventModel';
import {IEcommerceData} from '../../IGoogleTagManager';

/**
 * Represents PromotionClickEventModel
 */
export default class PromotionClickEventModel extends EventModel {
	public ecommerce: IEcommerceData;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		this.ecommerce = {
			promoClick: {
				promotions: [
					{
						id: data.id,
						name: data.name,
						creative: data.creative,
						position: data.position
					}
				]
			}
		};
	}
};
